import accountChecker from '../assets/voices/account-checker.m4a';
import bots from '../assets/voices/bots.m4a';
import dataExtraction from '../assets/voices/data-extraction.m4a';
import ddosTesting from '../assets/voices/ddos-testing.m4a';
import enterServer from '../assets/voices/enter-server.m4a';
import rconScan from '../assets/voices/rcon-scan.m4a';
import serverDatabase from '../assets/voices/server-database.m4a';
import serversParser from '../assets/voices/servers-parser.m4a';
import zerodayMethod from '../assets/voices/zeroday-method.m4a';
import paymentRequest from '../assets/voices/payment-request.m4a';

const voices = {
  'account-checker': accountChecker,
  'bots': bots,
  'data-extraction': dataExtraction,
  'ddos-testing': ddosTesting,
  'enter-server': enterServer,
  'rcon-scan': rconScan,
  'server-database': serverDatabase,
  'servers-parser': serversParser,
  'zeroday-method': zerodayMethod,
  'payment-request': paymentRequest,
};

let currentAudio = null;
let currentKey = null;
let lastPlayTime = 0;

export const playVoice = (voiceKey) => {
  const src = voices[voiceKey];
  if (!src) {
    console.warn(`Voice source not found for key: ${voiceKey}`);
    return;
  }

  const now = Date.now();
  if (currentKey === voiceKey && (now - lastPlayTime) < 350) {
    // Avoid double trigger in React StrictMode development builds and rapid transitions
    return;
  }

  // Emergency stop previous audio
  if (currentAudio) {
    try {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    } catch (e) {
      console.warn("Failed to stop previous audio:", e);
    }
  }

  const audio = new Audio(src);
  audio.volume = 0.85;
  currentAudio = audio;
  currentKey = voiceKey;
  lastPlayTime = now;

  audio.play().catch((err) => {
    console.warn(`Failed to play voice ${voiceKey}:`, err);
  });
};

export const stopVoice = () => {
  if (currentAudio) {
    try {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    } catch (e) {
      console.warn("Failed to stop audio:", e);
    }
    currentAudio = null;
    currentKey = null;
  }
};
